import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { startOfDay, subDays } from "date-fns";

interface TimelineSettingsState {
  timelineStart: string;
  visibleDays: number;
  timelineEnd: string | null;
  timelineLength: number | null;
}

const defaultOffset =
  Number(process.env.NEXT_PUBLIC_TIMELINE_DAYS_INTO_PAST) || 14;
const today = startOfDay(new Date());
const initialTimelineStart = startOfDay(subDays(today, defaultOffset));

const initialState: TimelineSettingsState = {
  timelineStart: initialTimelineStart.toISOString(),
  visibleDays: 7,
  timelineEnd: null,
  timelineLength: null,
};

export const timelineSettingsSlice = createSlice({
  name: "timelineSettings",
  initialState,
  reducers: {
    setTimelineStart: (state, action: PayloadAction<string>) => {
      state.timelineStart = action.payload;
    },
    setVisibleDays: (state, action: PayloadAction<number>) => {
      state.visibleDays = action.payload;
    },
    setTimelineEnd: (state, action: PayloadAction<string | null>) => {
      state.timelineEnd = action.payload;
    },
    setTimelineLength: (state, action: PayloadAction<number | null>) => {
      state.timelineLength = action.payload;
    },
  },
});

export const {
  setTimelineStart,
  setVisibleDays,
  setTimelineEnd,
  setTimelineLength,
} = timelineSettingsSlice.actions;

export default timelineSettingsSlice.reducer;
